// extracted by css-extract-rspack-plugin
export default {"tooltipTable":"cWhkp","tableBody":"CJxet","hasBottomSpacing":"ElKsZ","tableCell":"NwwZ8","tableFooter":"FSjcK"};